import { render, staticRenderFns } from "./user-infos.vue?vue&type=template&id=0e9de2ee&scoped=true"
import script from "./user-infos.vue?vue&type=script&lang=js"
export * from "./user-infos.vue?vue&type=script&lang=js"
import style0 from "./user-infos.vue?vue&type=style&index=0&id=0e9de2ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9de2ee",
  null
  
)

export default component.exports